import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { Browser, enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';
import { CategoryService, ChartComponent, ColumnSeriesService, IPointEventArgs, LineSeriesService, StackingColumnSeriesService } from '@syncfusion/ej2-angular-charts';

import { Chart, LineSeries, DateTime, Legend, Tooltip, ILoadedEventArgs, ChartTheme,Category, ColumnSeries, } from '@syncfusion/ej2-charts';
// import { Browser } from '@syncfusion/ej2-base';

@Component({
  selector: 'app-metric-chart-multi-series-staff-single',
  templateUrl: './metric-chart-multi-series-staff-single.component.html',
  styleUrls: ['./metric-chart-multi-series-staff-single.component.scss'],
  providers: [CategoryService, ColumnSeriesService, StackingColumnSeriesService, LineSeriesService],

})
export class MetricChartMultiSeriesStaffSingleComponent implements OnInit, OnChanges {

   // setup as observable?
   @Input() item_id?: any; // impliments on changes.
   @Input() item_data? // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full


  //syncfusion charts
  @ViewChild('chart_single')
  public chart: ChartComponent;
  public primaryXAxis: Object;

  // public chartData: Object[];
  public chartData: any;

public marker: Object;
public tooltip: Object;
public Chart2_marker: Object;
public Chart2_tooltip: Object;

public primaryYAxis: Object;
public cornerRadius: Object;
public chartArea: Object;
public animation: Object;
public pointColorMapping: string;


// Chart Staff User Solo
public chartData2: any;
public pointColorMapping2: string = "log_type_colour";
public tooltip2: Object;
public legendSettings2: Object;
  // Define default values
  private readonly DEFAULT_COLOR = "#cccccc";
  private readonly DEFAULT_ICON = "fa fa-question-circle";
 
  public highScoreAnnotation: any[] = [];
  public lowScoreAnnotations: any[] = [];
 
  primaryXAxis_Category = {
    // valueType: 'DateTimeCategory'
    valueType: 'Category',
    // valueType: "Category",
    title: "Activies",
    visible: true
    // valueType: 'DateTime'
    
  };
  zoom: { enableSelectionZooming: boolean; enablePan: boolean; mode: string; enableAnimation: boolean; };



  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService,
   private modalService: BsModalService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
   private _mysqlService: MysqlService,

  ) {

    this.tooltip2 = {
      enable: true
  };

    // Legend configuration
    this.legendSettings2 = {
      visible: true,
      position: 'Bottom',
      shape: 'Circle'
    };

    this.zoom = {
      enableSelectionZooming: true,
      enablePan: true,
      mode: 'XY',
      enableAnimation: true
      };



   }

  ngOnInit(): void {
  }

  
  ngOnChanges(changes: SimpleChanges) {

    if (changes.item_data) {
      this.item_data = changes.item_data.currentValue;

      
      this.chartData2 = this.transformItemData2ToChartData(this.item_data);
      this.calculateAnnotations();  // Calculate annotations when data updates

    }
  }




// Staff Chart
// Transformation function with default color and icon
transformItemData2ToChartData(data: any): any[] {
  return data.flatMap(user => 
    user.user_logs_array.map(log => ({
      log_type_name: log.log_type_name,
      count: log.count,
      log_type_colour: log.log_type_colour || this.DEFAULT_COLOR, // Default color
      log_type_icon: log.log_type_icon || this.DEFAULT_ICON, // Default icon
      score_difference_duration: log.score_difference_duration, 
      user_icon: user.user_icon,
      benchmark_duration: log.benchmark_duration,
      rating_duration: log.rating_duration
    }))
  );
}

 // Custom tooltip content function
 public getTooltipContent(args: any): string {

  console.log("Tooltip data:", args.point);  // Log point data for debugging

  const icon = args.point.log_type_icon || this.DEFAULT_ICON;
  const xValue = args.point.x;
  const yValue = args.point.y;

  return `<div style="display:flex;align-items:center;">
              <i class="fa ${icon}"></i> 
              ${xValue}: ${yValue} 
          </div>`;
}



public tooltipRender(args: any): void {
  // Access log_type_icon and other properties safely
  const icon = args.point?.log_type_icon || this.DEFAULT_ICON;
  const xValue = args.point?.x;
  const yValue = args.point?.y;

  // Set custom HTML for tooltip
  // args.tooltip.header = '';
  args.tooltip.template = `<div style="display:flex;align-items:center;">
                              <i class="${icon}" style="margin-right:5px;"></i> 
                              ${xValue}: ${yValue}
                          </div>`;
}




calculateAnnotations(): void {
  if (!this.chartData2 || this.chartData2.length === 0) return;

  const sortedData = [...this.chartData2].sort((a, b) => b.score_difference_duration - a.score_difference_duration);

  // Identify top and bottom values
  this.highScoreAnnotation = [sortedData[0]];
  this.lowScoreAnnotations = sortedData.slice(-3);

  console.log("High Score Annotation:", this.highScoreAnnotation);
  console.log("Low Score Annotations:", this.lowScoreAnnotations);
}





}
